import { render, staticRenderFns } from "./osamex.vue?vue&type=template&id=6de93844&scoped=true&"
import script from "./osamex.vue?vue&type=script&lang=js&"
export * from "./osamex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de93844",
  null
  
)

export default component.exports